import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { CurrencyProvider } from "./lib/currency";
import { Toaster } from "sonner";
import PageLoader from "./components/PageLoader";
import ErrorBoundary from "./components/ErrorBoundary";
import Home from "./pages/Home";
import Store from "./pages/Store";
import ApexConfigurator from "./pages/ApexConfigurator";
import Auth from "./pages/Auth";
import Checkout from "./pages/Checkout";
import OfferCheckout from "./pages/OfferCheckout";
import PaymentResult from "./pages/PaymentResult";
import MyVault from "./pages/MyVault";
import Admin from "./pages/Admin";
import Reviews from "./pages/Reviews";
import { VerifyEmail, ResetPassword } from "./pages/Misc";
import Legal from "./pages/LegalPages";

// Wraps every route so the app never renders a blank/black screen while auth
// is bootstrapping. Prevents the mobile-customer report of "screen went black".
function BootGate({ children }) {
  const { loading } = useAuth();
  if (loading) return <PageLoader/>;
  return children;
}

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <CurrencyProvider>
          <BrowserRouter>
            <Toaster theme="dark" position="top-center" richColors />
            <BootGate>
              <Routes>
              <Route path="/" element={<Home/>}/>
              <Route path="/store" element={<Store/>}/>
              <Route path="/apex/:id" element={<ApexConfigurator/>}/>
              <Route path="/auth" element={<Auth/>}/>
              <Route path="/checkout" element={<Checkout/>}/>
              <Route path="/offer-checkout/:offerId" element={<OfferCheckout/>}/>
              <Route path="/payment/result" element={<PaymentResult/>}/>
              <Route path="/my-vault" element={<MyVault/>}/>
              <Route path="/my-vault/:tab" element={<MyVault/>}/>
              <Route path="/admin" element={<Admin/>}/>
              <Route path="/reviews" element={<Reviews/>}/>
              <Route path="/verify-email" element={<VerifyEmail/>}/>
              <Route path="/reset-password" element={<ResetPassword/>}/>
              <Route path="/legal/:page" element={<Legal/>}/>
              <Route path="*" element={<Navigate to="/"/>}/>
            </Routes>
          </BootGate>
          </BrowserRouter>
        </CurrencyProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}
